





































































































import { Component, Vue, Inject } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Campaign } from '@/data/models/campaign.model';
import { Search, SortDirection } from '@/data/models/search.model';
import { download } from '@/data/utils/helper';
import { CampaignService } from '@/data/services/campaign.service';

@Component
export default class CampagnaList extends Vue {
	@Inject('CrudService') crudService!: CrudService<Campaign>;
	@Inject('CampaignService') campaignService!: CampaignService;

	rows: Campaign[] = [];
	loading: boolean = false;

	advancedSearch: Search = new Search('campaign');

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadCampagne() {

		const datareq = this.crudService.searchEntities(
			Campaign,
			'campaign',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Campaign,
			'campaign',
			this.advancedSearch
		);
		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	deleteCampagna(item: Campaign) {
		this.$emit('delete', item);
	}

	lockCampagna(item: Campaign) {
		this.$emit('lock', item);
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadCampagne();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadCampagne();
	}

	printContacts(row: Campaign) {
		const loading = this.$buefy.loading.open({});
		this.campaignService.printContacts(row.id).then((response) => {
			download(response, `stampa-contatti_${row.id}.pdf`);
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		}).finally(() => loading.close());
	}

}
